<div
  [ngClass]="
    !padding
      ? 'empty-page-container padding-yes'
      : 'empty-page-container padding-no'
  "
>
  <div class="info-container">
    <div class="title-size-4 font-omicron-medium line-height-title text-size-1">
      {{ contentEmpty }}
    </div>
  </div>
</div>
